import createCRUDObservable from 'redux-observable-crud'
import { combineEpics } from 'redux-observable'
import { Observable } from 'rxjs'
import DailyAttendanceActions, { DailyAttendanceRedux, DailyAttendanceTypes } from '../Redux/DailyAttendanceRedux'
import { notificationFail } from '../Redux/NotificationActions'

const dailyAttendanceCrudObservable = createCRUDObservable({
  mainRedux: DailyAttendanceRedux,
  reduxPath: 'dailyAttendance',
})

const dailyAttendanceExcelEpic = (action$, store, { Api }) =>
  action$.ofType(DailyAttendanceTypes.DailyAttendanceExcelRequest)
    .mergeMap(() => (
      Observable
        .fromPromise(Api.dailyAttendance.getDailyAttendanceExcel()
          .then(response => response)
          .catch(error => error))
        .flatMap((response) => {
          const { status } = response
          if (!(status >= 200 && status < 300)) {
            return [notificationFail('Falló la descarga')]
          }
          const file = response.headers['content-disposition']
          const index = file.indexOf('=')
          const fileName = file.substring(index + 1, file.length)
          const url = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', fileName)
          document.body.appendChild(link)
          link.click()
          return [
            DailyAttendanceActions.DailyAttendanceExcelSuccess(),
          ]
        })
    ))

export const dailyAttendanceObservers = Object.assign({}, dailyAttendanceCrudObservable.observers, {})

export const dailyAttendanceEpic = combineEpics(
  dailyAttendanceCrudObservable.epic,
  dailyAttendanceExcelEpic,
)



// WEBPACK FOOTER //
// ./src/Data/Observables/DailyAttendanceObservable.js